import { useModal } from '../ui/ModalProvider';

export const useCreateSignPreview = () => {
  const { signModal } = useModal();
  const createSignPreview = (signFile, callback) => {
    if (signFile) {
      const element = document.querySelector(`[name="${signModal.code}"]`);
      const signBtn = element.querySelector('.btn-sign');
      const signPreview = element.querySelector('.sign-preview');
      const img = signPreview.querySelector('img');

      const { width, height } = signBtn.getBoundingClientRect();

      img.src = signFile;
      img.onload = () => {
        img.style.width = `${width}px`;
        img.style.height = `${height}px`;
        element.dataset.error = 'N';
        element.dataset.status = 'Y';
      };
      callback();
    }
  };

  return { createSignPreview };
};
